"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootMyPropertySagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var Pages_1 = require("@/rendering/common/Pages");
var MyPropertyApiSaga_1 = require("@/pages/myproperty/sagas/api/MyPropertyApiSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var EformPropertyDtoToEformPropertyState_1 = require("@/pages/document/transformers/EformPropertyDtoToEformPropertyState");
var MyPropertyAction_1 = require("@/pages/myproperty/actions/MyPropertyAction");
var format_1 = require("@/utils/format");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var StorageApi_1 = require("@/api/browser/StorageApi");
var EformDtoToEformState_1 = require("@/pages/document/transformers/EformDtoToEformState");
var MyDocumentApiSaga_1 = require("@/pages/document/sagas/api/MyDocumentApiSaga");
var WindowApi_1 = require("@/api/browser/WindowApi");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var PropertyListOrderEnum_1 = require("@/pages/document/states/PropertyListOrderEnum");
var MyPropertySortToPropertyListOrder_1 = require("@/pages/document/transformers/MyPropertySortToPropertyListOrder");
var REPORT_SOLD_DISABLED_FOR_DAY = 3; // days
var getCurrentSuggestionIndex = function (state) { return state.myproperty.currentSuggestionIndex; };
var getKeyword = function (state) { return state.myproperty.keyword; };
var getSuggestions = function (state) { return state.myproperty.suggestions; };
var getSuggestionAtIndex = function (state, i) { return state.myproperty.suggestions[i]; };
var getIsMyListingPage = function (state) { return state.page === Pages_1.Pages.MY_LISTINGS; };
var getCardHasEform = function (state) { return state.myproperty.eformProperties && state.myproperty.eformProperties.length > 0; };
var getSearchKeyword = function (state) { return state.myproperty.keyword; };
var getCurrentReportSoldPropertyId = function (state) { return state.myproperty.eformProperties[state.myproperty.reportSoldPropertySelectedIndex].property_id; };
var getCurrentReportSoldSelectedIndex = function (state) { return state.myproperty.reportSoldPropertySelectedIndex; };
var getCurrentEformProperties = function (state) { return state.myproperty.eformProperties; };
var getReportSoldForm = function (state) {
    var p = state.myproperty;
    return {
        salePriceStr: p.reportSoldSoldPrice,
        leasePriceStr: p.reportSoldLeasePrice,
        agency: p.reportSoldAgency,
        soldDateStr: p.reportSoldSoldDate,
    };
};
var getMyListings = function (keyword, page, propertyListOrderEnum, propertyListOrderIsAsc) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(MyPropertyApiSaga_1.getMyListingsApi, keyword, page, propertyListOrderEnum, propertyListOrderIsAsc)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
};
var getMyViewings = function (keyword, page, propertyListOrderEnum, propertyListOrderIsAsc) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(MyPropertyApiSaga_1.getMyViewingsApi, keyword, page, propertyListOrderEnum, propertyListOrderIsAsc)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
};
var doSearchByKeyword = function (keyword, page, propertyListOrderEnum, propertyListOrderIsAsc) {
    var lang, isMyListingPage, result, eformProperties;
    if (page === void 0) { page = 1; }
    if (propertyListOrderEnum === void 0) { propertyListOrderEnum = PropertyListOrderEnum_1.PropertyListOrderEnum.PROPERTY_ID; }
    if (propertyListOrderIsAsc === void 0) { propertyListOrderIsAsc = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsMyListingPage)];
            case 2:
                isMyListingPage = _a.sent();
                return [4 /*yield*/, effects_1.call(isMyListingPage ? getMyListings : getMyViewings, keyword, page, propertyListOrderEnum, propertyListOrderIsAsc)];
            case 3:
                result = _a.sent();
                if (!result || !result.results)
                    return [2 /*return*/];
                eformProperties = result.results.map(EformPropertyDtoToEformPropertyState_1.EformPropertyDtoToEformPropertyState(lang));
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setResult(eformProperties, result.currentPage, result.totalPage, result.totalRecords))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearchByKeyword, '')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnCardClickLoadDocuments = function () {
    var payload, index, hasEform, lang, email, properties, property, id, isMyListingPage, result, eforms;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_CARD_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload;
                return [4 /*yield*/, effects_1.select(getCardHasEform)];
            case 2:
                hasEform = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getUserEmail)];
            case 4:
                email = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentEformProperties)];
            case 5:
                properties = _a.sent();
                property = properties[index];
                id = property.property_id;
                return [4 /*yield*/, effects_1.select(getIsMyListingPage)];
            case 6:
                isMyListingPage = _a.sent();
                return [4 /*yield*/, effects_1.call(isMyListingPage ? MyPropertyApiSaga_1.getMyListingDocumentByPropertyApi : MyPropertyApiSaga_1.getMyViewingDocumentByPropertyApi, id, 1)];
            case 7:
                result = _a.sent();
                if (!result || !result.results)
                    return [2 /*return*/];
                eforms = result.results.map(EformDtoToEformState_1.EformDtoToEformState(lang, email.toLowerCase()));
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setDocumentOnPropertyCard(index, eforms))];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchOnReportSold = function () {
    var payload, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_REPORT_SOLD_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload;
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldPropertyIndex(index))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchEnter = function () {
    var suggestionIndex, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                suggestionIndex = _a.sent();
                if (!(suggestionIndex === -1)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 3:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.call(doSearchByKeyword, keyword)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(false))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestions([]))];
            case 7:
                _a.sent();
                return [3 /*break*/, 11];
            case 8: return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.onSuggestionClick(suggestionIndex))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchSearchBlur = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var setPropertySoldReportedToLocalStorage = function (id) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!id)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(StorageApi_1.setLocalStorage, "sold_report_" + id, "" + Date.now())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnReportSoldSubmitSaveToLocalStorage = function () {
    var propertyId, propertyIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_REPORT_SOLD_SUCCESS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentReportSoldPropertyId)];
            case 2:
                propertyId = _a.sent();
                return [4 /*yield*/, effects_1.call(setPropertySoldReportedToLocalStorage, propertyId)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentReportSoldSelectedIndex)];
            case 4:
                propertyIndex = _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldDisableIndex(propertyIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSetResultUpdateSoldReportStateFromLocalStorage = function () {
    var properties, i, property, id, lastReportStr, lastReportDate, now, daySinceLastReport;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take([MyPropertyAction_1.default.MY_PROPERTY_SET_RESULT, GlobalAction_1.default.ON_DOM_LOADED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentEformProperties)];
            case 2:
                properties = _a.sent();
                i = 0;
                _a.label = 3;
            case 3:
                if (!(i < properties.length)) return [3 /*break*/, 7];
                property = properties[i];
                id = property.property_id;
                return [4 /*yield*/, effects_1.call(StorageApi_1.readLocalStorage, "sold_report_" + id)];
            case 4:
                lastReportStr = _a.sent();
                if (!lastReportStr)
                    return [3 /*break*/, 6];
                lastReportDate = (new Date(parseInt(lastReportStr))).getTime();
                now = Date.now();
                daySinceLastReport = (now - lastReportDate) / 3600000 / 24;
                if (!(daySinceLastReport <= REPORT_SOLD_DISABLED_FOR_DAY)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldDisableIndex(i))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i++;
                return [3 /*break*/, 3];
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchOnReportSoldSubmit = function () {
    var _a, salePriceStr, leasePriceStr, agency, soldDateStr, propertyId, soldDate, reportSoldResponse;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_REPORT_SOLD_SUBMIT)];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldLoading(true))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.select(getReportSoldForm)];
            case 3:
                _a = _b.sent(), salePriceStr = _a.salePriceStr, leasePriceStr = _a.leasePriceStr, agency = _a.agency, soldDateStr = _a.soldDateStr;
                return [4 /*yield*/, effects_1.select(getCurrentReportSoldPropertyId)];
            case 4:
                propertyId = _b.sent();
                return [4 /*yield*/, effects_1.call(format_1.default.parseDateStr, soldDateStr)];
            case 5:
                soldDate = _b.sent();
                return [4 /*yield*/, effects_1.call(MyPropertyApiSaga_1.reportSoldApi, propertyId, salePriceStr, leasePriceStr, soldDate, agency)];
            case 6:
                reportSoldResponse = _b.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldLoading(false))];
            case 7:
                _b.sent();
                if (!(!reportSoldResponse || !reportSoldResponse.success)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('reportsold_failed', BigPopupState_1.BigPopupType.FAILED, 'failed', 'reportSoldFailed'))];
            case 8:
                _b.sent();
                return [3 /*break*/, 14];
            case 9: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('reportsold_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'reportSoldSuccess'))];
            case 10:
                _b.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.onReportSoldSuccess())];
            case 11:
                _b.sent();
                return [4 /*yield*/, effects_1.delay(500)];
            case 12:
                _b.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setReportSoldHidden())];
            case 13:
                _b.sent();
                _b.label = 14;
            case 14: return [3 /*break*/, 0];
            case 15: return [2 /*return*/];
        }
    });
};
var watchOnView = function () {
    var payload, index, key, key2, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_EFORM_VIEW_CLICKED_BY_DOCUMENT_PATH)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload.index, key = payload.key;
                key2 = key;
                return [4 /*yield*/, effects_1.call(MyDocumentApiSaga_1.getDownloadUrl, key2)];
            case 2:
                result = _a.sent();
                if (!(result && result.url)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(WindowApi_1.openTab, result.url)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var doKeywordSuggestions = function (keywordInput) {
    var keyword, isChinese, minAutocompleteLength;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                keyword = format_1.default.normalize(keywordInput.trim());
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 1:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestions, keyword)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
var onlyUnique = function (value, index, array) {
    return array.indexOf(value) === index;
};
var doSuggestion = function () {
    var keywordInput, keyword, isChinese, lang, minAutocompleteLength, suggestions, suggestionTextPcIndex, suggestionsLocalized, suggestionsDistinct;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getKeyword)];
            case 1:
                keywordInput = _a.sent();
                keyword = format_1.default.normalize(keywordInput.trim());
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 2:
                isChinese = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 2;
                if (!(keyword.length < minAutocompleteLength)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(false))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestions([]))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, effects_1.call(doKeywordSuggestions, keyword)];
            case 8:
                suggestions = _a.sent();
                if (!suggestions)
                    return [2 /*return*/];
                suggestionTextPcIndex = lang.indexOf('en') === 0 ? 0 : suggestions.length - 1;
                suggestionsLocalized = suggestions.map(function (it) { return it.name.split('|')[suggestionTextPcIndex].trim().split('-Block')[0]; });
                suggestionsDistinct = suggestionsLocalized.filter(onlyUnique);
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(true))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestions(suggestionsDistinct))];
            case 11:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var delayedKeywordSearch = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(200)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSuggestion)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchKeywordType = function () {
    var task;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                task = null;
                return [4 /*yield*/, effects_1.takeLatest(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_KEYWORD_CHANGED, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, effects_1.fork(delayedKeywordSearch)];
                                case 1:
                                    task = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_ENTER, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!task) return [3 /*break*/, 2];
                                    return [4 /*yield*/, effects_1.cancel(task)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSuggestionClick = function () {
    var payload, index, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SUGGESTION_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload;
                return [4 /*yield*/, effects_1.select(getSuggestionAtIndex, index)];
            case 2:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(-1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestions([]))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSearchKeyword(keyword))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.onSearchEnter())];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchSuggestionNext = function () {
    var suggestionIndex, suggestions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_NEXT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                suggestionIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestions)];
            case 3:
                suggestions = _a.sent();
                if (!(suggestionIndex > -1 && suggestionIndex + 1 === suggestions.length)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(0))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(suggestionIndex + 1))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchSuggestionPrev = function () {
    var suggestionIndex, suggestions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SEARCH_PREV)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                suggestionIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestions)];
            case 3:
                suggestions = _a.sent();
                if (!(suggestionIndex === 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(suggestions.length - 1))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionIndex(suggestionIndex - 1))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchOnChangePage = function () {
    var payload, page, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_CHANGE_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                page = payload;
                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 2:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.call(doSearchByKeyword, keyword, page)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnSortChanged = function () {
    var payload, sort, keyword, _a, propertyListOrder, isAsc;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MyPropertyAction_1.default.MY_PROPERTY_ON_SORT_CHANGE)];
            case 1:
                payload = (_b.sent()).payload;
                sort = payload;
                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 2:
                keyword = _b.sent();
                return [4 /*yield*/, effects_1.call(MyPropertySortToPropertyListOrder_1.MyPropertySortToPropertyListOrder, sort)];
            case 3:
                _a = _b.sent(), propertyListOrder = _a.propertyListOrder, isAsc = _a.isAsc;
                return [4 /*yield*/, effects_1.call(doSearchByKeyword, keyword, 1, propertyListOrder, isAsc)];
            case 4:
                _b.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var rootMyPropertySagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnInit: watchOnInit,
    watchOnCardClickLoadDocuments: watchOnCardClickLoadDocuments,
    watchOnReportSold: watchOnReportSold,
    watchOnReportSoldSubmit: watchOnReportSoldSubmit,
    watchSearchEnter: watchSearchEnter,
    watchSearchBlur: watchSearchBlur,
    watchOnReportSoldSubmitSaveToLocalStorage: watchOnReportSoldSubmitSaveToLocalStorage,
    watchOnSetResultUpdateSoldReportStateFromLocalStorage: watchOnSetResultUpdateSoldReportStateFromLocalStorage,
    watchOnView: watchOnView,
    watchKeywordType: watchKeywordType,
    watchSuggestionClick: watchSuggestionClick,
    watchSuggestionNext: watchSuggestionNext,
    watchSuggestionPrev: watchSuggestionPrev,
    watchOnChangePage: watchOnChangePage,
    watchOnSortChanged: watchOnSortChanged,
};
exports.rootMyPropertySagas = rootMyPropertySagas;
